export const PDF_HEADER = {
    pt: [
        {
            _id: 'patrolPointCode',
            name: 'ID',
        },
        {
            _id: 'name',
            name: 'Nome',
        },
    ],
    en: [
        {
            _id: 'patrolPointCode',
            name: 'ID',
        },
        {
            _id: 'name',
            name: 'Name',
        },
    ],
}
